import { Component, Input, OnInit, Renderer2, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { ReflectionService } from '../../shared/utilities/reflection.service';
import { ColumnDefinition } from '../table.types';

@Component({
    selector: 'app-table-header',
    templateUrl: './table-header.component.html',
    styleUrls: ['./table-header.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class TableHeaderComponent implements OnInit {
    @Input() column: ColumnDefinition;
    @ViewChild('headerWrapper', { read: ViewContainerRef }) headerWrapper: ViewContainerRef;

    constructor(private renderer2: Renderer2, private reflection: ReflectionService) {}

    ngOnInit(): void {}

    computeHeaderLabel(column: ColumnDefinition) {
        if (column.headerHtml) {
            return '';
        }
        if (column && column.headerLabel) {
            return column.headerLabel;
        }
        column.headerLabel = this.reflection.toTitleCase(column.property.split('.').join(' '));
        return column.headerLabel;
    }
}
